// extracted by mini-css-extract-plugin
export default {"brandPromo":"uF-z","carousel":"vF-z"};